import React from 'react';
import styles from '../../styles/pages/Blog.module.css';

/**
 * Component that displays meaningful feedback when blog posts can't be loaded
 */
export function FallbackMessage({ error }) {
  return (
    <div className={styles.fallbackMessage}>
      <h3>Blog Post Loading Issues</h3>
      <p>We're having trouble loading the blog posts.</p>
      
      {error && (
        <div className={styles.errorDetails}>
          <p><strong>Error details:</strong> {error}</p>
        </div>
      )}
      
      <div className={styles.fallbackActions}>
        <button 
          className={styles.reloadButton}
          onClick={() => window.location.reload()}
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}
